import { memo, PropsWithoutRef, useCallback } from 'react'

import { Delete } from '@mui/icons-material'
import { Box, IconButton, Tooltip } from '@mui/material'
import { SmepExpManifest } from '@nativewaves/nw-cloud-sdk/content'
import { Row, Table } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { useProgramDeleteMutation } from 'hooks/mutations/content'
import { useConfirm } from 'hooks/utils'

type SelectionToolbarActionProps = {
  selectedRows: Row<SmepExpManifest>[]
  tableInstance: Table<SmepExpManifest>
}

const SelectionToolbarActionsRaw = ({ selectedRows, tableInstance }: PropsWithoutRef<SelectionToolbarActionProps>) => {
  const { t } = useTranslation(['common', 'domain'])
  const { mutateAsync: deleteExpManifest } = useProgramDeleteMutation()
  const confirm = useConfirm()

  const handleDeleteSelectedExpManifests = useCallback(async () => {
    try {
      await confirm(t('areYouSure'))

      await Promise.allSettled(selectedRows.map((row) => deleteExpManifest({ programId: row.original.id })))

      tableInstance.resetRowSelection()
    } catch (_) {}
  }, [confirm, deleteExpManifest, selectedRows, t, tableInstance])

  return (
    <Box sx={{ ml: 'auto', mr: 2, display: 'flex', alignItems: 'center', columnGap: 1 }}>
      <Tooltip title={t('domain:Workspace.ExpManifest.deleteSelected')} placement="top">
        <IconButton sx={{ ml: 'auto', mr: 2, my: 'auto' }} size="medium" onClick={handleDeleteSelectedExpManifests}>
          <Delete fontSize="medium" />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

export const SelectionToolbarActions = memo(SelectionToolbarActionsRaw)
